import { render, staticRenderFns } from "./MassiveImportSupervisorsCollaboratorsModal.vue?vue&type=template&id=6ab22378&scoped=true&"
import script from "./MassiveImportSupervisorsCollaboratorsModal.vue?vue&type=script&lang=js&"
export * from "./MassiveImportSupervisorsCollaboratorsModal.vue?vue&type=script&lang=js&"
import style0 from "./MassiveImportSupervisorsCollaboratorsModal.vue?vue&type=style&index=0&id=6ab22378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab22378",
  null
  
)

export default component.exports